module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n正在获取您的用户信息请稍后\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d95e9b76!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/uniteLogin/UniteAccept.vue
// module id = 1598
// module chunks = 18